import request from "@/utils/request";

export function subjectGet(params) {
    return request({
        url: "/api/services/app/Subject/Get",
        method: "get",
        params
    });
}

export function subjectGetAll(params) {
    return request({
        url: "/api/services/app/Subject/GetAll",
        method: "get",
        params
    });
}

export function subjectGetAmountChangeHistory(params) {
    return request({
        url: "/api/services/app/Subject/GetAmountChangeHistory",
        method: "get",
        params
    });
}

export function subjectGetChangeHistory(params) {
    return request({
        url: "/api/services/app/Subject/GetChangeHistory",
        method: "get",
        params
    });
}

export function subjectGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Subject/GetAllForDropdown",
        method: "get",
        params
    });
}

export function subjectGetCount(params) {
    return request({
        url: "/api/services/app/Subject/GetCount",
        method: "get",
        params
    });
}

export function subjectGetSubjectTypes(params) {
    return request({
        url: "/api/services/app/Subject/GetChildSubjectTypes",
        method: "get",
        params
    });
}

export function subjectGetSubjectForms(params) {
    return request({
        url: "/api/services/app/Subject/GetSubjectForms",
        method: "get",
        params
    });
}

export function subjectGetImportFilePath(params) {
    return request({
        url: "/api/services/app/Subject/GetImportFilePath",
        method: "get",
        params
    });
}

export function subjectImport(data) {
    return request({
        url: "/api/services/app/Subject/Import",
        method: "post",
        data
    });
}

export function subjectCreate(data) {
    return request({
        url: "/api/services/app/Subject/Create",
        method: "post",
        data
    });
}

export function subjectCreateMany(data) {
    return request({
        url: "/api/services/app/Subject/CreateMany",
        method: "post",
        data
    });
}

export function subjectCreateBatch(data) {
    return request({
        url: "/api/services/app/Subject/CreateBatch",
        method: "post",
        data
    });
}

export function subjectUploadFile(data) {
    return request({
        url: "/api/services/app/Subject/UploadFile",
        method: "post",
        data
    });
}

export function subjectUpdate(data) {
    return request({
        url: "/api/services/app/Subject/Update",
        method: "put",
        data
    });
}

export function subjectDelete(params) {
    return request({
        url: "/api/services/app/Subject/Delete",
        method: "delete",
        params
    });
}

export function subjectDeleteMany(data) {
    return request({
        url: "/api/services/app/Subject/DeleteMany",
        method: "post",
        data
    });
}

export function subjectExport(data) {
    return request({
        url: "/api/services/app/Subject/ExportData",
        method: "post",
        data
    });
}



// WEBPACK FOOTER //
// ./src/api/subject.js